import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { slackQueryKeys } from "./slackQueryKeys";

/** The workspaces this org has connected. Readable by any org member. */
export function useSlackConnections(orgId?: string) {
  const { slackService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: slackQueryKeys.connections(resolvedOrgId),
    queryFn: ({ signal }) =>
      slackService.listConnections(resolvedOrgId, { abortSignal: signal }),
    staleTime: 30_000,
  });
}
